module.exports = __webpack_public_path__ + "img/prev.1dc9cfd.png";